import { SET_USERS, CLEAR_USERS } from "../actions/usersActions";

const initialState = {
  users: [],
  agencies: []
}

function usersReducer(state = initialState, action) {
  switch (action.type) {
  case SET_USERS:
    return {
      ...state,
      users: action.payload,
      agencies: action.agencies
    }
  case CLEAR_USERS:
    return {
      ...state,
      users: [],
      agencies: []
    }
  default:
    return state;
  }
}

export default usersReducer;